export default {
  auth: () => import("/app/layouts/auth.vue").then(m => m.default || m),
  blank: () => import("/app/layouts/blank.vue").then(m => m.default || m),
  default: () => import("/app/layouts/default.vue").then(m => m.default || m),
  profile: () => import("/app/layouts/profile.vue").then(m => m.default || m),
  settings: () => import("/app/layouts/settings.vue").then(m => m.default || m),
  standalone: () => import("/app/layouts/standalone.vue").then(m => m.default || m),
  tv: () => import("/app/layouts/tv.vue").then(m => m.default || m)
}